import Dragger from "antd/lib/upload/Dragger";
import React, { FC, useEffect, useRef, useState } from "react";
import UIModal from "../../../../../shared/components/UIModal";
import Modal from "antd/lib/modal/Modal";
import {
  InboxOutlined,
  ExclamationCircleOutlined,
  UploadOutlined,
} from "@ant-design/icons";

import "./bulkUpload.scss";
import { Button, message, Upload } from "antd";
import { AcceptedUploadTypes } from "../../../../../shared/components/EmptyState/acceptedUploadTypes";
import { convertJSONToFormData } from "../../../../../shared/utils/converJsonToFormData";
import excerciseService from "../../../../../services/ExcerciseService/excercise.service";
import Notification from "../../../../../shared/components/Notification";
import { NotificationTypes } from "../../../../../enums/notificationTypes";
import { ExamService } from "../../../../../services/ExamService/exam.service";
import { ExamExerciseService } from "../../../../../services/ExamService/ExerciseService/exercise.service";
import { PreviousPaperService } from "../../../../../services/ExamService/PreviousPaperService/previouspaper.service";
import ContentLibraryService from "../../../../../services/ContentLibraryService/contentLibrary.service";
import { useLocation } from "react-router-dom";

interface BulkUploadProps {
  showDocUpload?: boolean,
  params?: any,
  visible: boolean;
  closeHandler: () => void;
}

const BulkUpload: FC<BulkUploadProps> = (props) => {
  const { visible, closeHandler, params, showDocUpload = false } = props;
  const [uploadedXslx, setUploadedXslx] = useState<any>(null);
  const [uploadedZip, setUploadedZip] = useState<any>(null);
  const [uploadedDoc, setUploadedDoc] = useState<any>(null);
  const [buttonLoading, setButtonLoading] = useState<boolean>(false);
  const location = useLocation();
  const [uploadErrors, setUploadErrors] = useState<any[]>([]);
  const [errorRow, setErrorRow] = useState<any>("");

  const beforeUpload = (file: File) => {
    const validTypes = AcceptedUploadTypes.exerciseUpload.allFiles.includes(
      file.type
    );
    if (!validTypes) {
      message.error("You can only upload ZIP/XSLX file!").then();
      return Upload.LIST_IGNORE;
    }
    return validTypes;
  };

  // const handleChange = (files: any) => {
  //   if (AcceptedUploadTypes.exerciseUpload.xslx.includes(files?.file?.type)) {
  //     setUploadedXslx(files?.file);
  //   } else if (
  //     AcceptedUploadTypes.exerciseUpload.zip.includes(files?.file?.type)
  //   ) {
  //     setUploadedZip(files?.file);
  //   } else {
  //     message.error("You can only upload ZIP/XSLX file!").then();
  //   }
  // };
  const handleChangeXlsx = (files: any) => {
    if (AcceptedUploadTypes.exerciseUpload.xslx.includes(files?.file?.type)) {
      setUploadedXslx(files?.file);
    } else {
      message.error("You can only upload XSLX file!").then();
    }
  };
  const handleChangeZip = (files: any) => {
    if (AcceptedUploadTypes.exerciseUpload.zip.includes(files?.file?.type)) {
      setUploadedZip(files?.file);
    } else {
      message.error("You can only upload ZIP file!").then();
    }
  };

  const handleChangeDoc = (files: any) => {
    if (AcceptedUploadTypes.exerciseUpload.doc.includes(files?.file?.type)) {
      setUploadedDoc(files?.file);
    } else {
      message.error("You can only upload word file!").then();
    }
  };

  const handleSubmit = () => {
    if (uploadedDoc) {
      setButtonLoading(true);
      setUploadErrors([]);
      const payload: any = {};
      payload["file"] = uploadedDoc?.originFileObj;
      payload["ContentLibraryId"] = params?.contentId || 0
      payload["ClassroomId"] = params?.classId || 0
      payload["SubjectId"] = params?.subjectId || 0
      payload["ChapterId"] = params?.chapterId || 0

      const formData = convertJSONToFormData(payload);
      excerciseService.uploadExerciseQuestionsDocument(
        formData,
        () => {
          message.success("Uploaded successfully!");
          setUploadedDoc(null);
          setUploadedXslx(null);
          setUploadedZip(null);
          closeHandler();
        },
        (errors: any, row: any) => {
          setUploadErrors(errors);
          setErrorRow(row);
        },
        () => {
          setButtonLoading(false);
        }
      );

    } else if (uploadedXslx) {
      setButtonLoading(true);
      setUploadErrors([]);
      const payload: any = {};
      if (uploadedXslx) {
        payload["data_attachment"] = uploadedXslx?.originFileObj;
        if (uploadedZip)
          payload["image_attachment"] = uploadedZip?.originFileObj;
      }
      const formData = convertJSONToFormData(payload);
      if (
        location.pathname.includes("exams") &&
        location.pathname.includes("previous_paper")
      ) {
        PreviousPaperService.uploadBulkPaperQuestions(
          formData,
          () => {
            message.success("Uploaded successfully!");
            setUploadedDoc(null);
            setUploadedXslx(null);
            setUploadedZip(null);
            closeHandler();
          },
          (errors: any, row: any) => {
            setUploadErrors(errors);
            setErrorRow(row);
          },
          () => {
            setButtonLoading(false);
          }
        );
      } else if (location.pathname.includes("content-library")) {
        ContentLibraryService.uploadBulkContentQuestions(
          formData,
          () => {
            message.success("Uploaded successfully!");
            setUploadedDoc(null);
            setUploadedXslx(null);
            setUploadedZip(null);
            closeHandler();
          },
          (errors: any, row: any) => {
            setUploadErrors(errors);
            setErrorRow(row);
          },
          () => {
            setButtonLoading(false);
          }
        );
      } else if (location.pathname.includes("exams")) {
        ExamExerciseService.uploadBulkExamExerciseQuestions(
          formData,
          () => {
            message.success("Uploaded successfully!");
            setUploadedDoc(null);
            setUploadedXslx(null);
            setUploadedZip(null);
            closeHandler();
          },
          (errors: any, row: any) => {
            setUploadErrors(errors);
            setErrorRow(row);
          },
          () => {
            setButtonLoading(false);
          }
        );
      } else {
        excerciseService.uploadBulkExerciseQuestions(
          formData,
          () => {
            message.success("Uploaded successfully!");
            setUploadedDoc(null);
            setUploadedXslx(null);
            setUploadedZip(null);
            closeHandler();
          },
          (errors: any, row: any) => {
            setUploadErrors(errors);
            setErrorRow(row);
          },
          () => {
            setButtonLoading(false);
          }
        );
      }
    } else {
      message.warn("Attach file!");

    }
  };

  return (
    <UIModal
      visible={visible}
      closeModal={() => {
        setUploadErrors([]);
        setUploadedDoc(null)
        setUploadedXslx(null);
        setUploadedZip(null);
        closeHandler();
      }}
      closable={false}
      submitProps={{
        text: "Submit",
        clickHandler: () => handleSubmit(),
        buttonLoading: buttonLoading,
      }}
      cancelProps={{
        text: "Cancel",
        clickHandler: () => {
          setUploadErrors([]);
          setUploadedDoc(null)
          setUploadedXslx(null);
          setUploadedZip(null);
          closeHandler();
        },
      }}
    >
      <>
        <p className="bulk-upload__title">Bulk Upload</p>
        {/* <Dragger
          maxCount={2}
          beforeUpload={beforeUpload}
          onChange={handleChange}
          accept={
            "zip,application/octet-stream,application/zip,application/x-zip,application/x-zip-compressed,.csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
          }
          className="bulk-upload__dragger"
        >
          <p className="ant-upload-drag-icon">
            <InboxOutlined />
          </p>
          <p className="ant-upload-text">
            Click or drag file to this area to upload
          </p>
          <p className="ant-upload-hint">
            Support for a single or bulk upload. Strictly prohibit from
            uploading company data or other band files
          </p>
        </Dragger> */}
        <div className="upload__wrapper">
          <div className="upload__item">
            <div className="file__type">XLSX: </div>
            <Upload
              maxCount={1}
              beforeUpload={beforeUpload}
              onChange={handleChangeXlsx}
              accept={
                ".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
              }
            >
              <Button className="upload__btn" icon={<UploadOutlined />}>
                Click to Upload
              </Button>
            </Upload>
          </div>

          {showDocUpload && <div className="upload__item">
            <div className="file__type">Word: </div>
            <Upload
              maxCount={1}
              beforeUpload={beforeUpload}
              onChange={handleChangeDoc}
              accept={
                ".doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
              }
            >
              <Button className="upload__btn" icon={<UploadOutlined />}>
                Click to Upload
              </Button>
            </Upload>
          </div>
          }

          <div className="upload__item">
            <div className="file__type">ZIP: </div>
            <Upload
              maxCount={1}
              beforeUpload={beforeUpload}
              onChange={handleChangeZip}
              accept={
                "zip,application/octet-stream,application/zip,application/x-zip,application/x-zip-compressed"
              }
            >
              <Button className="upload__btn" icon={<UploadOutlined />}>
                Click to Upload
              </Button>
            </Upload>
          </div>
        </div>
        <div className="info__note">* ZIP is optional, upload only when you have images in xlsx.</div>
        {uploadErrors?.length ? (
          <div className="upload__errors">
            {uploadErrors?.map((value, index) => {
              return (
                <p className="error__text">
                  <span>
                    <ExclamationCircleOutlined />
                  </span>{" "}
                  {errorRow === 'no_row'
                    ? `${value?.questionId}: ${value?.errorMessage}`
                    : `row: ${errorRow}; ${value}`
                  }

                </p>
              );
            })}
            {/* <p className="error__text">Row: {errorRow}</p> */}
          </div>
        ) : (
          ""
        )}
      </>
    </UIModal>
  );
};

export default BulkUpload;
